import { useCallback } from "react";

import { useMutationWithState } from "hooks";

export function useCreateClientComment(
  clientId,
  draftGid,
  taskUuid,
  clientWorkflowUuid = ""
) {
  const mutationFactory = useCallback(() => {
    const query = `mutation createComment($clientId: ID!, $content: String!, $draftGid: ID, $taskUuid: UUID, $cwfUuid: UUID){
        createComment(clientId: $clientId, content: $content, draftGid: $draftGid, taskUuid: $taskUuid,
                clientWorkflowUuid: $cwfUuid) {
            successMessage
            commentUuid
        }                
    }`;

    const resolver = ({ data, errors }) => {
      return {
        data: data.createComment,
        errors: errors,
      };
    };

    return { query, resolver };
  }, []);

  const [mutation, { errors, loading }] = useMutationWithState(mutationFactory);

  return {
    creatingErrors: errors,
    isCreatingComment: loading,
    createComment: async (content) => {
      return mutation({
        clientId: clientId,
        content: content,
        draftGid: draftGid,
        taskUuid: taskUuid || null,
        cwfUuid: clientWorkflowUuid || null,
      });
    },
  };
}

export default useCreateClientComment;
